import { render } from "./VascularHomeView.vue?vue&type=template&id=5cebde64"
import script from "./VascularHomeView.vue?vue&type=script&lang=js"
export * from "./VascularHomeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__